/*
 * MiniDis mobile navigation drawer fallback.
 *
 * Debutify normally binds .js-drawer-open-button-left to #NavDrawer via
 * timber.Drawers. This delegated handler is intentionally defensive: it lets
 * the native theme handler run first and only opens/closes the drawer when the
 * expected class change did not happen. This keeps the existing Debutify
 * behaviour intact while making the mobile menu resilient in theme previews,
 * section reloads and pages where the original drawer binding is missed.
 */
(function () {
  'use strict';

  if (window.__mdMobileDrawerFallbackLoaded) return;
  window.__mdMobileDrawerFallbackLoaded = true;

  var OPEN_CLASS = 'js-drawer-open';
  var BODY_DIRECTION_CLASS = 'js-drawer-open-left';
  var DRAWER_ID = 'NavDrawer';
  var OPEN_SELECTOR = '.js-drawer-open-button-left[aria-controls="NavDrawer"]';
  var CLOSE_SELECTOR = '#NavDrawer .js-drawer-close';

  function getDrawer() {
    return document.getElementById(DRAWER_ID);
  }

  function getOpeners() {
    return document.querySelectorAll(OPEN_SELECTOR);
  }

  function setOpenerState(isOpen) {
    var openers = getOpeners();
    for (var i = 0; i < openers.length; i += 1) {
      openers[i].setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }
  }

  function manualOpen(trigger) {
    var drawer = getDrawer();
    if (!drawer || drawer.classList.contains(OPEN_CLASS)) return;

    drawer.classList.remove('is-closing');
    drawer.classList.add(OPEN_CLASS);
    drawer.setAttribute('aria-hidden', 'false');

    document.body.classList.add(OPEN_CLASS);
    document.body.classList.add(BODY_DIRECTION_CLASS);

    setOpenerState(true);

    if (trigger) {
      trigger.setAttribute('aria-expanded', 'true');
    }
  }

  function manualClose() {
    var drawer = getDrawer();
    if (!drawer) return;

    drawer.classList.remove(OPEN_CLASS);
    drawer.classList.remove('is-closing');
    drawer.setAttribute('aria-hidden', 'true');

    document.body.classList.remove(OPEN_CLASS);
    document.body.classList.remove(BODY_DIRECTION_CLASS);

    setOpenerState(false);
  }

  function closest(element, selector) {
    if (!element || element === document) return null;
    if (element.closest) return element.closest(selector);

    while (element && element.nodeType === 1) {
      if (element.matches && element.matches(selector)) return element;
      element = element.parentElement;
    }

    return null;
  }

  document.addEventListener('click', function (event) {
    var opener = closest(event.target, OPEN_SELECTOR);

    if (opener) {
      event.preventDefault();

      /*
       * The Debutify direct click listener fires before this delegated
       * document listener. Wait one tick and only step in if it did not open.
       */
      window.setTimeout(function () {
        var drawer = getDrawer();
        if (drawer && !drawer.classList.contains(OPEN_CLASS)) {
          manualOpen(opener);
        }
      }, 0);

      return;
    }

    var closeButton = closest(event.target, CLOSE_SELECTOR);
    if (closeButton) {
      event.preventDefault();

      window.setTimeout(function () {
        var drawer = getDrawer();
        if (drawer && drawer.classList.contains(OPEN_CLASS)) {
          manualClose();
        }
      }, 0);

      return;
    }

    var drawer = getDrawer();
    if (!drawer || !drawer.classList.contains(OPEN_CLASS)) return;

    var overlay = closest(event.target, '.overlay-drawer');
    if (overlay && !closest(event.target, '#NavDrawer')) {
      manualClose();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' && event.keyCode !== 27) return;

    var drawer = getDrawer();
    if (drawer && drawer.classList.contains(OPEN_CLASS)) {
      manualClose();
    }
  });

  function initialiseAria() {
    var drawer = getDrawer();
    if (!drawer) return;

    var isOpen = drawer.classList.contains(OPEN_CLASS);
    drawer.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    setOpenerState(isOpen);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseAria);
  } else {
    initialiseAria();
  }

  /* Shopify Theme Editor can reload either section without a full page load. */
  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(initialiseAria, 0);
  });
})();
